import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 44193E2D-1EAB-4BA1-9D32-C7E149F53E89
 * name bottle-tonic-outline
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bottle-tonic-outline.svg
 * tags
 * - Science 
 */
export const BottleTonicOutlineIcon = createSvgIcon(<><path d="M13 4H11L10 2H14L13 4M19 13V22H5V13C5 10.24 7.24 8 10 8V6H9V5H15V6H14V8C16.76 8 19 10.24 19 13M17 13C17 11.35 15.65 10 14 10H10C8.35 10 7 11.35 7 13V20H17V13Z" /></>, 'BottleTonicOutlineIcon');
export default BottleTonicOutlineIcon